import React, { useState, useEffect } from 'react'
import styles from "../style/components/concertVideo.module.css"
import { Link } from 'react-router-dom'
import likeIconNull from "../assets/svg/like null.svg"
import likeIcon from "../assets/svg/like.svg"
import { useHistory } from 'react-router-dom'
import Modal from './Modal'
import SecureVideo from "./SecureVideo";

const VideoCard = ({ video, setFavoritesVideos, favouritesVideos, isBougth }) => {
	const [hovered, setHovered] = useState(false)
	const history = useHistory()
	const [bougthVideoModal, setBougthVideoModal] = useState(false)
  const [user, setUser] = useState({})


	const handleClickLike = (e) => {
		e.preventDefault()
		e.stopPropagation()
		if (favouritesVideos.includes(video._id)) {
			setFavoritesVideos(prevState => prevState.filter((elem) => elem !== video._id))
		} else {
			setFavoritesVideos([...favouritesVideos, video._id])
		}
	}

	const handleClickCard = (e) => {
		if (isBougth) {
			e.preventDefault()
			setBougthVideoModal(true)
		} else {
			history.push(`/concert/${video?._id}`)
		}
	}

	useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"))
    if (token) {
      setUser(token.userObj)
    }

  }, [])
	

	return (
		<div className={styles.concertVideosItem} >
			<Link onClick={handleClickCard}>
				{isBougth ?
					<div className={styles.videosItemVideo}>
						<img
							src={video.posterUrl}
							alt={video.title}
							style={{ display: hovered ? "none" : "block" }}
						/>
					</div>
					: 
						<div className={styles.videosItemVideo} onMouseOver={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
							<img
								src={video.posterUrl}
								alt={video.title}
								style={{ display: hovered ? "none" : "block" }}
							/>
							<video
								src={video.trailerUrl}
								autoPlay
								muted
								loop
								playsInline
								style={{ display: hovered ? "block" : "none" }}
							/>
							<div className={styles.videosFavourites}>
								<button onClick={handleClickLike}>
									{favouritesVideos.includes(video._id) ? <img src={likeIcon} alt="like" /> : <img src={likeIconNull} alt="unlike" />}
								</button>

							</div>

						</div>
				}

			</Link >
			<div className={styles.videosItemDescription}>
				<Link onClick={handleClickCard}>
					<h1>{video.title}</h1>
					{isBougth && <p>{video.description}</p>}
				</Link>
			</div>
			{
				bougthVideoModal && 
				<Modal onClose={() => setBougthVideoModal(false)}>
					<div className={styles.cartVideoRightContainer}>
						<video className={styles.cartVideoRightVideo} src={video?.videoUrl} autoPlay muted loop playsInline controls   controlsList="nodownload"   onContextMenu={(e) => e.preventDefault()}/>
						{/* <SecureVideo className={styles.cartVideoRightVideo} src={video?.videoUrl}/> */}
					</div>
				</Modal>
			}
			{
				user._id === process.env.REACT_APP_ADMIN_ID && 
				<></> 
			}
		</div>
	)
}

export default VideoCard
